import { Box, Typography } from '@mui/material'
import { useState } from 'react';
import LangLink from '../../../Localization/LangLink';
import LanguageMenu from './LanguageMenu';
import { Bar, fontLink, fullCenter, greenButton } from '../../../base';
import { Txt } from '../../../Routes/Localized';
import MobileMenu from '../../MobileBar/MobileMenu';
import { useMobileMenu } from '../../MobileBar/MobileMenuProvider';
import SearchDialog from './SearchDialog';

export const publicBarNavigation = [
    { text: <Txt id={"10013"} />, link: 'result/sample' },
    { text: <Txt id={"10012"} />, link: 'pricing' },
    { text: <Txt id={"10014"} />, link: 'contact' },
    { text: <Txt id={"10015"} />, link: 'blog' },
    { text: <Txt id={"10016"} />, link: 'about' },
];

export function MainBarNavigation() {
    const [hovered, setHovered] = useState(null);

    const getNavProps = (i) => {
        return {
            onMouseEnter: () => setHovered(i),
            onMouseLeave: () => {
                if (i === hovered) {
                    setHovered(null);
                }
            },
            onClick: () => {
                if (i === hovered) {
                    setHovered(null);
                }
            },
            onContextMenu: (e) => setHovered(null)
        }
    }
    return <>

        {publicBarNavigation.map((n, i) => <Box
            key={`NavLinkBox${i}`}
            name={`NavLinkBox${i}`}
            component={LangLink}
            sx={{ mx: '6px', textDecoration: 'none' }}
            to={n.link}
            {...getNavProps(i)}>
            <Typography
                sx={{
                    textWrap: 'nowrap', fontFamily: 'inter', fontWeight: 700, ...fontLink, p: '10px',
                    transform:
                        hovered === i
                            ? "translateY(-3px)"
                            : "translateY(0px)",
                    transitionDuration: "200ms",
                }}>
                {n.text}
            </Typography>
        </Box>)}
    </>;
}

function MainBarComputer({ langOnlySwitch }) {
    const [dialog, setDialog] = useState(false);

    return <>
        <SearchDialog dialog={dialog} setDialog={setDialog} />
        <MainBarNavigation langOnlySwitch={langOnlySwitch} />
        <Box sx={{ ml: 'auto', ...fullCenter, flexDirection: 'row', }}>
            <LanguageMenu langOnlySwitch={langOnlySwitch} />
            <Box
                component={LangLink} sx={{ mx: '6px', textDecoration: 'none' }}
                to={"find_report"}
            >
                <Typography
                    sx={{
                        fontFamily: 'inter', textWrap: 'nowrap', fontWeight: 700, ...fontLink, p: '10px',
                    }}>
                    <Txt id="121012" />
                </Typography>
            </Box>

            <Box sx={{ cursor: 'pointer', textDecoration: 'none' }} onClick={() => setDialog(true)}>
                <div style={{ userSelect: 'none', display: 'block' }} >
                    <Box sx={{ ...greenButton, borderRadius: '50px', height: '36px', ...fullCenter, }}>
                        <Typography sx={{
                            fontFamily: 'inter', textWrap: 'nowrap', fontWeight: 700, ...fontLink, maxWidth: '400px', px: '15px', color: '#fff',
                        }}>
                            <Txt id={"11027"} />
                        </Typography>
                    </Box>
                </div>
            </Box>
        </Box></>
}

export default function AppBar({
    colors = {
        top: 'white',
        main: '#F8F8FC',
    },
    langOnlySwitch
}) {
    const { isMobileBar } = useMobileMenu();

    return (
        <Bar colors={colors} threshold={10}>
            {!isMobileBar ? <MainBarComputer langOnlySwitch={langOnlySwitch} /> : <MobileMenu />}
            {/*mobile && <MobileNavigation navigation={nav} />*/}
        </Bar>
    )
}
